/***********
 * Setup *
 ***********/

// Axios
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const csrfMetaNode = document.querySelector('meta[name="csrf-token"]');

if (csrfMetaNode) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfMetaNode.getAttribute('content');
}

// Vue
import { createApp } from 'vue';
import mitt from 'mitt';

const emitter = mitt();
window.events = emitter;

// Vue - Messaging
window.flash = function (message, type, duration, dismissable = false) {
    if (message.length) {
        window.events.emit('flash', [message, type, duration, dismissable]);
    }
};

const app = createApp({});

// Vue - Register components
const files = require.context('./', true, /\.vue$/i)

files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default));

// Charts
window.charts = [];

const rerenderCharts = () => {
    setTimeout(() => {
        window.charts.forEach(chart => {
            chart.resize();
        });
    }, 0);
}

if ('orientation' in screen) {
    screen.orientation.addEventListener('change', rerenderCharts);
} else {
    // e.g. Safari
    window.addEventListener('orientationchange', rerenderCharts);
}

//Laravel Echo
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

// Vue - Initialise app
app.mount('#app');

/************
 * Margetts *
 ************/

require('./margetts/navigation.js');
require('./margetts/partials.js');
require('./margetts/components/accordion.js');
require('./margetts/components/tabs.js');

/*******
 * PWA *
 *******/

require('./pwa');
